import { createContext } from 'react';

import { IPageShortcutsContext } from './types';

/**
 * Default no-op context so `usePageShortcuts` is safe even if a page renders
 * outside the provider (the register/unregister ops are stable references, which
 * keeps the hook's effect deps clean).
 */
const noop = (): void => undefined;

export const defaultPageShortcutsContext: IPageShortcutsContext = {
  register: noop,
  unregister: noop,
  getShortcuts: () => [],
  version: 0,
};

export const PageShortcutsContext = createContext<IPageShortcutsContext>(
  defaultPageShortcutsContext,
);
